<script lang="ts">
  import Container from "$lib/components/Container/Container.svelte";
  import InfoCard from "../InfoCard.svelte";
  import Column from "$lib/components/Column/Column.svelte";
  import Grid from "$lib/components/Grid/Grid.svelte";

  interface InfoCards {
    icon: string;
    title: string;
    description: string;
    customIcon?: boolean;
  }

  export let cards: InfoCards[];
</script>

<style lang="scss">
  .info-card {
    padding-top: 24px;
    border-top: 1px solid $outline;
    &--first {
      border: none;
      padding-top: 0;
    }

    @include breakpoint(md) {
      padding-top: 40px;
      &--first,
      &--second {
        border: none;
        padding-top: 0;
      }
    }

    @include breakpoint(lg) {
      border: none;
      padding-top: 0;
    }
  }

  .hr {
    border-top: 1px solid $on-surface;
    @include retina {
      border-top: 0.5px solid $on-surface;
    }
  }

  .wrapper {
    padding: 32px 0;
    background: $surface;
    position: relative;
    z-index: 50;

    @include breakpoint(md) {
      padding: 44px 0;
    }
    @include breakpoint(lg) {
      padding: 52px 0;
      border-bottom: 1px solid $on-surface;

      @include retina {
        border-bottom: 0.5px solid $on-surface;
      }
    }
  }
</style>

{#if cards}
  <div class="hr"></div>
  <div class="wrapper info-cards-wrapper">
    <Container>
      <Grid smGap="24px">
        {#each cards as { icon, title, description, customIcon }, i (title)}
          <Column smSpan={4} mdSpan={4} lgSpan={3} mdStart={0} lgStart={0}>
            <div
              class="info-card {i === 0
                ? 'info-card--first'
                : i === 1
                  ? 'info-card--second'
                  : ''}"
            >
              <InfoCard {icon} {title} {description} {customIcon} />
            </div>
          </Column>
        {/each}
      </Grid>
    </Container>
  </div>
{/if}
